export function callScheme(url: string) {
  const iframe = document.createElement('iframe');
  iframe.setAttribute('style', 'border:0;widthL0;height:0;');
  iframe.src = url;
  document.querySelector('body')?.appendChild(iframe);
  setTimeout(() => {
    iframe.remove();
  }, 100);
}

export namespace AppScheme {
  export function tel(phoneUrl: string | undefined) {
    const telScheme = `tel://${phoneUrl}`;
    callScheme(telScheme);
  }

  export function sms(phone: string, message: string) {
    const smsScheme = `sms:${phone};?&body=${encodeURIComponent(message)}`;
    callScheme(smsScheme);
  }
}
